module.exports = __webpack_public_path__ + "img/j.1933b1fd.jpg";